import React from "react";
import { addTree, editTree } from "../../../action/treeAction";
import { Form, FormControl, Button } from "react-bootstrap";
// import tableStore from '../../../store/tableStore';
import treeStore from "../../../store/treeStore";
import { TemplateHandler } from './TemplateHandler';
import tableStore from "../../../store/tableStore";
import { SourceListV2 } from "./SourceListV2";
import { NodeTypes } from "./NodeTypes";
import { FormTextBox } from "../../components/FormTextBox";
import { ModalFormButton } from "./ModalFormButton";
import { ThemeHandler } from './themeHandler';

/**Dynamic Form for handling the Data needed for creating a new node*/
export default class ModalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            rootParent: true,
            sourceShow: false,
            siteShow: true,

        };
        // this.setStateOfComponent();
    }
    /**Resets the state of the component */
    setStateOfComponent = (type) => this.setState({
        node: {
            name: "",
            shortName: "",
            type: type ? type : "",
            notes: ""
        },
        sources: []
    });
    /**Handles the changing of the type because its a dynamic
     * component lots of little things change depending on what is chosen
     */
    selectChanger = changer => {
        const value = changer.target.value;
        if (value === "docLib") {
            this.props.documents(true);
            this.setState({ sourceShow: true });
        } else {
            this.props.documents(false);
            this.setState({ sourceShow: false });
        }
        this.setState(prevState => ({
            node: { ...prevState.node, type: value }
        }));
        let title;
        let theme = false;
        if (value === "docLib") {
            title = "Document Library";
        } else if (value === "hub") {
            theme = true;
            title = "Hub Site";
        } else if (value === "site") {
            theme = true;
            title = "Site";
        } else if (value === "page") {
            title = "Page";
        }
        this.props.setTheme(theme);
        this.props.titleChanger(title);
    };
    /**When the components mounted onto the dom checks if its a new node or edit node
     * if its an edit node it has to set up the dynamic UI depending on the data recieved
     */
    componentWillMount() {
        this.setState({ readOnly: this.props.readOnly, sourcesAllowed: this.props.sourcesAllowed });
        if (this.props.parent.type) {
            this.setState({ node: this.props.parent });
            if (this.props.parent.type === "docLib") {
                this.setState({
                    sourceShow: true,
                    rootParent: false,
                    siteShow: false
                });
                this.setStateOfComponent("docLib");
                this.props.titleChanger("Document Library");
            } else if (this.props.parent.type === "hub") {
                this.props.titleChanger("Hub Site");
            } else if (this.props.parent.type === "site") {
                this.setState({ rootParent: false });
                this.props.titleChanger("Site");
            }
        } else if (treeStore.tree[this.props.parent]) {
            if (treeStore.tree[this.props.parent].type === "hub") {
                this.setState({ rootParent: false, });
                this.setStateOfComponent("site");
                this.props.titleChanger("Site");
            } else if (treeStore.tree[this.props.parent].type === "site") {
                this.setState({
                    rootParent: false,
                    siteShow: false,
                });
                this.setStateOfComponent("docLib");
                this.props.titleChanger("Document Library");
            }

        } else {
            this.setState(prevState => ({
                node: { ...prevState.node, type: "hub" }
            }));
            this.props.titleChanger("Hub Site");

        }
        //get the templates and set them in the state
        if (tableStore.table.templates) {
            this.setState({ templates: tableStore.table.templates });
        } else {
            this.setState({ templates: [] });
        }
        if (this.props.parent.edit) {

            this.setState({ edit: true, node: this.props.parent });
        } else {
            this.setState(prevState => ({
                node: { ...prevState.node, parent: this.props.parent }
            }));
        }
    }
    componentWillUnmount() {
        this.setState({ node: undefined });
    }
    /**Generic handler for text changes on a input text field */
    textChanger = (ev, input) => {
        let value = ev.target.value;
        const inputName = ev.target.name;
        //short name / URL can't have spaces
        if (inputName === "shortName") {
            value = value.replace(/\s/g, '');
        }
        this.setState(prevState => ({
            node: { ...prevState.node, [inputName]: value }
        }));
    };
    /**Submits the creation/edit to the backend */
    submit = async () => {
        const { node } = this.state;
        const errors = [];
        if (node.name === undefined) {
            errors.push("No title has been added");
        }
        if (node.type === undefined) {
            errors.push("No type, please delete and re-enter node");
        }
        if (node.name) {
            if (node.name.length <= 0) {
                errors.push("leave a more meaningful title");
            }
        }

        if (errors.length > 0) {
            const joinedString = errors.join("\n");
            alert("Please fill out correct details: \n" + joinedString);
            return;
        }
        // const node = this.state.node;
        if (node.edit) {
            delete node.edit;
        }
        this.state.edit
            ? editTree(this.state.node)
            : addTree(this.state.node);

        this.props.hide();
        // if(this.)
    };
    componentWillReceiveProps(nextProps) {
        //If the sources arent the same as the sources here update the sources
        if (nextProps.parent.sources !== this.state.node.sources) {
            this.setState((prevState) => ({ node: { ...prevState.node, sources: nextProps.parent.sources } }));
        }
        if (nextProps.theme !== this.state.node.theme) {
            this.setState((prevState) => ({ node: { ...prevState.node, theme: nextProps.theme } }));

        }
    }
    /**sets the sourceShow if the doclib is selected */
    componentDidUpdate() {
        if (this.state.sourceShow === false && this.state.node.type === "docLib") {
            this.setState({ sourceShow: true }, () => this.props.setShowSource(true));
        }
    }
    setTemplate = (templateID) => this.setState((prevState) => ({ node: { ...prevState.node, templateId: templateID } }));
    onSelectTheme = (themeName) => this.setState((prevState) => ({ node: { ...prevState.node, theme: themeName } }));
    render() {
        const { node, templates } = this.state;
        let capitalType;
        //@todo fix at some point very hacky
        if (!node.type) {
            capitalType = "Hub";
        } else {
            capitalType = node.type.charAt(0).toUpperCase() + node.type.slice(1);
        }
        const title = capitalType + " Title";
        return (
            <Form>
                <FormTextBox formLabel={title} textChanger={this.textChanger}
                    name="name" placeholder={title} value={node.name || ""}
                    readOnly={this.state.readOnly || false} />

                <FormTextBox formLabel={capitalType + " URL"} textChanger={this.textChanger}
                    name="shortName" placeholder={`${capitalType} URL - leave blank for auto-generate`} value={node.shortName || ""}
                    readOnly={this.state.readOnly || false} />


                <FormTextBox formLabel={"Notes"} textChanger={this.textChanger}
                    name="notes" placeholder={"Notes"} value={node.notes || ""}
                    readOnly={true} as="textarea" />

                <NodeTypes selectChanger={this.selectChanger} type={node.type || undefined} readOnly={this.state.readOnly || false}
                    rootParent={this.state.rootParent} siteShow={this.state.siteShow} />

                <SourceListV2 onRemoveSource={this.props.onRemoveSource} sourceShow={this.state.sourceShow || false} sources={node.sources} />

                <TemplateHandler nodeType={node.type || ""} selectedTemplate={node.templateId || 0}
                    templates={templates} onSelectTemplate={this.setTemplate} />
                <ThemeHandler nodeType={node.type || ""} onSelectTheme={this.onSelectTheme}
                    selectedTheme={node.theme || 0} themes={tableStore.table.theme || undefined} />
                <ModalFormButton readOnly={this.state.readOnly} sourcesAllowed={this.state.sourcesAllowed}
                    type={node.type} edit={this.state.edit} onSubmit={this.submit} />
            </Form >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tree/node/modalForm.js